module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1416.06e3d2de.jpg";